<template>
    <div class="product">
        <navBar></navBar>
        <div class="p-banner"></div>
        <div class="p-title">
            <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
            <div class="p-title-r">
                <div class="p-title-txt">Civa家校服务</div>
                <div class="p-title-intro">Civa家校服务（微信小程序），家长督学贴心小助手</div>
            </div>
        </div>
        <div class="p-content-top">
            <div class="p-top-img">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-top.png" alt="">
            </div>
            <ul class="p-item-text">
                <li class="p-item-text-li">
                    <div class="li">
                        <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-icon1.png" alt="">
                        <h5 class="top-title">微官网</h5>
                        <p class="top-desc">快速了解学校新闻动态</p>
                    </div>
                    <div class="li">
                        <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-icon2.png" alt="">
                        <h5 class="top-title">课堂评价</h5>
                        <p class="top-desc">及时接收孩子课堂表现</p>
                    </div>
                </li>
                <li class="p-item-text-li">
                    <div class="li">
                        <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-icon3.png" alt="">
                        <h5 class="top-title">学习报表</h5>
                        <p class="top-desc">每周定时发送孩子学习周报</p>
                    </div>
                    <div class="li">
                        <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-icon4.png" alt="">
                        <h5 class="top-title">作业情况</h5>
                        <p class="top-desc">随时掌握孩子作业情况</p>
                    </div>
                </li>
            </ul>
        </div>
        <div class="line"></div>
        <div class="p-title">
            <img class="p-header" src="https://restaskimg.civaonline.cn/imagesH5/product/header.png" alt="">
            <div class="p-title-r">
                <div class="p-title-txt">校内通</div>
                <div class="p-title-intro">高效便捷的智能校区管理系统、校区一体化管理、家校零距离互动</div>
            </div>
        </div>
        <div class="p-content">
            <div class="p-content-item p-item-1">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-1.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title line-1"><span>C聊</span></h4>
                    <p class="p-item-text-intro">教师家长实时聊天、多位家庭成员账号共同关注孩子成长</p>
                </div>
            </div>
            <div class="p-content-item p-item-2">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-2.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>考勤管理</span></h4>
                    <p class="p-item-text-intro">点名签到，在线请假方便高效，签到提醒安全放心</p>
                </div>
            </div>
            <div class="p-content-item p-item-3">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-3.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>智能巡堂</span></h4>
                    <p class="p-item-text-intro">智能化教务巡堂系统、实时播报巡堂结果、教学成果一目了然</p>
                </div>
            </div>
            <div class="p-content-item p-item-4">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-4.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>校长信箱</span></h4>
                    <p class="p-item-text-intro">校长直接了解家长反馈、校区管理更透明</p>
                </div>
            </div>
            <div class="p-content-item p-item-5">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-5.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title"><span>缴费管理</span></h4>
                    <p class="p-item-text-intro">在线缴费高效便捷、校区营收数据实时查阅</p>
                </div>
            </div>
            <div class="p-content-item p-item-6">
                <img src="https://restaskimg.civaonline.cn/imagesH5/product/par-6.png" alt="">
                <div class="p-item-text">
                    <h4 class="p-item-text-title line-6"><span>班级圈</span></h4>
                    <p class="p-item-text-intro">随时分享学生在校精彩照片/视频，学生成长档案永久留存</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import navBar from '@/components/navBar';
export default {
  components: {
    navBar,
  },
}
</script>

<style scoped lang="less">
.product{
    .p-banner{
        background: url("https://restaskimg.civaonline.cn/imagesH5/product/parent-banner.png") no-repeat center center / cover;
    }
    .p-content-top{
        margin-top: 52px;
        .p-top-img{
            padding: 0 32px;
            img{
                width: 100%;
            }
        }
        .p-item-text{
            margin-top: 30px;
            padding-bottom: 12px;
        }
        .p-item-text-li{
            padding: 0 62px 37px;
            display: flex;
            width: 100%;
            box-sizing: border-box;
            justify-content: space-between;
            .li{
                font-family: SyMedium;
                text-align: left;
                img{
                    width: 100px;
                }
                .top-title{
                    font-size: 28px;
                    color: #293340;
                    font-weight: normal;
                    padding: 20px 0 10px;
                }
                .top-desc{
                    font-size: 24px;
                    color: #4D5560;
                    line-height: 33px;
                }
            }
        }
    }
    .p-content{
        padding: 0 32px 80px;
        .p-content-item{
            background: rgba(212,255,216,.25);
            padding-bottom: 40px;
            margin-top: 200px;
            img{
                height: 480px;
                margin-top: -140px;
            }
            .p-item-text{
                margin-top: 30px;
                .p-item-text-title:before{
                    background: #2BD1A7;
                }
                .line-1:before{
                    width: 52px;
                }
                .line-6:before{
                    width: 96px;
                }
                .p-item-text-intro{
                    text-align: left;
                    padding: 0 32px;
                }
            }
        }
        .p-item-1{
            margin-top: 180px;
        }
        .p-item-2{
            margin-top: 195px;
            img{
                margin-top: -128px;
            }
        }
        .p-item-3{
            img{
                margin-top: -132px;
            }
        }
        .p-item-4{
            margin-top: 188px;
            img{
                margin-top: -118px;
            }
        }
        .p-item-5{
            img{
                margin-top: -134px;
            }
        }
        .p-item-6{
            height: 459px;
            margin-top: 232px;
            img{
                margin-top: -180px;
            }
        }
    }
}
</style>
